import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import dayjs from "dayjs";
import { userAuthStatus } from "../../services/RouteAuth";
import { clearCache } from "../../services/functions";
import { checkPushSubscription } from "../../serviceWorkerRegistration";
import { hadRecentPushNavigation } from "../../services/pushNavigationClock";

const RedirectToHome = () => {
  const history = useHistory(); // ✅ always called
  const userStatus = userAuthStatus(); // reads localStorage

  const [exitTime, setExitTime] = useState(dayjs());
  const [startTime, setStartTime] = useState(dayjs());

  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState === "hidden") setExitTime(dayjs());
      if (document.visibilityState === "visible") {
        checkPushSubscription();
        setStartTime(dayjs());
      }
    };
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  useEffect(() => {
    if (userStatus !== "full") return; // ✅ guard inside effect

    const diffInMinutes = Math.abs(startTime.diff(exitTime, "minutes"));
    const diffInSeconds = Math.abs(startTime.diff(exitTime, "seconds"));

    if (diffInMinutes > 4) {
      const currentPath = window.location.pathname;
      // The app came back because a notification was tapped: that notification
      // decides where to go, not the "back to home after a while" rule.
      if (currentPath !== "/home" && !hadRecentPushNavigation()) {
        console.log("redirecting to home. Diff in minutes:", diffInMinutes);
        
        // If we're inside the shopping widget, force a full page reload
        // to destroy the widget's internal router and navigate to /home correctly
        const SHOP_BASE = "/shopping-widget";
        if (currentPath.startsWith(SHOP_BASE)) {
          window.location.href = "/home";
        } else {
          history.push("/home", { showNotificationsModal: true });
        }
      }
      clearCache();
    } else if (diffInSeconds > 5) {
      clearCache();
    }
  }, [userStatus, startTime, exitTime, history]);

  return null; // ✅ always return something
};

export default RedirectToHome;
